<div *ngIf="!isDisabled" class="itb-checkbox">
  <itb-text [className]="'text-default text-color-primary'" [text]="label"></itb-text><span *ngIf="isRequired"
    class="error-msg"> *</span>
  <div style="margin-top: 10px;">
    <mat-checkbox *ngFor="let box of checkboxArray; let i=index" [labelPosition]="box.position"
      [checked]="box.isSelected || box.isChecked" [disabled]="box.isDisabled"
      (change)="onChangeEvent($event,i,box.label)">
      {{box.label}}</mat-checkbox>
  </div>
</div>
<div *ngIf="isDisabled" class="itb-checkbox">
  <itb-text [className]="'text-default text-color-primary'" [text]="label"></itb-text><span *ngIf="isRequired"
    class="error-msg"> *</span>
  <div style="margin-top: 10px;">
    <mat-checkbox *ngFor="let box of checkboxArray; let i=index" [labelPosition]="box.position" [disabled]="isDisabled"
      [checked]="box.isSelected || box.isChecked">{{box.label}}</mat-checkbox>
  </div>
</div>